import React, { useCallback, useMemo } from "react";
import { DisplayMessage } from "../../../../../services/helpers";
import SignableDocumentsEditor from "../SignableDocumentsEditor";
import { Box } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { PictureAsPdf } from "@material-ui/icons";

const PREVIEW_GRID_PROPS = { container: { justifyContent: "center" } };
const ACCEPTED_FILES = [".pdf"];

const SignableDocumentsDocumentEditorSection = React.memo(({
  resources,
  showPreview,
  htmlEditorValue,
  handleHTMLchange,
  documentPdf,
  setDocumentPdf,
  dealerGroupId,
  existingPdfUrl,
  markPreviewAsViewed,
  documentContext,
}) => {
  const showDropzone = !documentPdf;

  const handlePreviewIcon = useCallback((fileObject, classes) => {
    const fileUrl = URL.createObjectURL(fileObject.file);

    const iconProps = {
      className: classes.image,
      onClick: () => {
        window.open(fileUrl);
        setTimeout(() => {
          URL.revokeObjectURL(fileUrl);
        }, 10000);
      },
    };

    return <PictureAsPdf style={{ cursor: "pointer" }} {...iconProps} />;
  }, []);

  const handleAlert = useCallback((message, variant) =>
    variant === "error" ? DisplayMessage(message, variant) : undefined
  , []);

  const dropzoneProps = useMemo(() => ({ disabled: !!htmlEditorValue }), [htmlEditorValue]);

  return (
    <>
      <SignableDocumentsEditor
        resources={resources}
        showPreview={showPreview}
        value={htmlEditorValue}
        onChange={handleHTMLchange}
        markPreviewAsViewed={markPreviewAsViewed}
        dealerGroupId={dealerGroupId}
        disabled={!!documentPdf}
        documentContext={documentContext}
      />

      {showDropzone && (
        <Box display="flex" justifyContent="center">
          <DropzoneArea
            previewGridProps={PREVIEW_GRID_PROPS}
            acceptedFiles={ACCEPTED_FILES}
            filesLimit={1}
            showAlerts={false}
            onAlert={handleAlert}
            showPreviews={true}
            previewText=""
            getPreviewIcon={handlePreviewIcon}
            dropzoneClass={`dropzone-signabledocuments dropzone large ${htmlEditorValue ? "disabled" : ""}`}
            dropzoneParagraphClass={"dropzone-p"}
            maxFileSize={30000000}
            dropzoneText={resources["DropPdfFileOrClickToSelectFile"]}
            onChange={setDocumentPdf}
            dropzoneProps={dropzoneProps}
          />
        </Box>
      )}
    </>
  );
});

export default SignableDocumentsDocumentEditorSection;
